import React, { useState } from "react";
import { saveAsDraft } from "../RoofSelection/roofFunction";
import "./sideNav.css";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useSelector } from "react-redux";

function SideNav({ active }) {
  const [draftLoader, setDraftLoader] = useState(false);
  const [show, setShow] = useState(false);
  const conUser = useSelector((state) => state?.conUser);
  const reportInfo = useSelector((state) => state?.reportInfo);
  const user = conUser?.user;

  const roofInfo = useSelector((state) => state.roof);
  const quantityInfo = useSelector((state) => state.quantity);
  const userType = sessionStorage.getItem("userType");
  const [tooltip, setTooltip] = useState("");

  const pathName = window.location.pathname;

  const [showLogout, setShowLogout] = useState(false);
  const handleClose = () => {
    setShow(false);
    setShowLogout(false);
  };
  const navigate = useNavigate();

  const logOut = () => {
    sessionStorage.clear();
    navigate("/SignIn");
  };

  const myProject = (value) => {
    if (
      pathName === "/createProject" ||
      pathName === "/analytics" ||
      pathName === "/design" ||
      pathName === "/electrical" ||
      pathName === "/financial" ||
      pathName === "/summary"
    ) {
      setShow(true);
    } else {
      navigate(value);
    }
  };

  const noProjectSave = () => {
    const RemoveItem = [
      "projects",
      "cid",
      "customerName",
      "projectId",
      "roofPolygons",
      "structureItem",
      "myData",
      "imageSrc",
      "ImageSrc",
    ];
    RemoveItem.forEach((key) => {
      sessionStorage.removeItem(key);
    });
    navigate("/Dashboard");
  };

  return (
    <>
      <div className="nav">
        {/* Admin */}
        {userType === "admin" && (
          <div className="sideNavIcon" onClick={() => myProject("/admin")}>
            {tooltip === "admin" && (
              <h1 className="toolTip">
                <div className="sideArrow"></div>
                Admin
              </h1>
            )}
            <svg
              className={`mouse-hover ${active === "admin" ? "active" : ""}`}
              onMouseEnter={() => setTooltip("admin")}
              onMouseLeave={() => setTooltip("")}
              width="20"
              height="14"
              viewBox="0 0 19 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.279 7.2383C17.1257 6.71842 16.3893 6.71842 16.2361 7.2383L16.1989 7.36439C16.101 7.69657 15.7216 7.85373 15.4175 7.68808L15.3021 7.6252C14.8261 7.36594 14.3054 7.88664 14.5647 8.36261L14.6275 8.47804C14.7932 8.78216 14.636 9.16159 14.3038 9.2595L14.1778 9.29666C13.6579 9.44989 13.6579 10.1863 14.1778 10.3395L14.3038 10.3767C14.636 10.4746 14.7932 10.854 14.6275 11.1581L14.5647 11.2736C14.3054 11.7495 14.8261 12.2702 15.3021 12.011L15.4175 11.9481C15.7216 11.7824 16.101 11.9396 16.1989 12.2718L16.2361 12.3979C16.3893 12.9178 17.1257 12.9178 17.279 12.3979L17.3161 12.2718C17.414 11.9396 17.7935 11.7824 18.0976 11.9481L18.213 12.011C18.689 12.2702 19.2097 11.7495 18.9504 11.2736L18.8875 11.1581C18.7219 10.854 18.8791 10.4746 19.2112 10.3767L19.3373 10.3395C19.8572 10.1863 19.8572 9.44989 19.3373 9.29666L19.2112 9.2595C18.8791 9.16159 18.7219 8.78216 18.8875 8.47804L18.9504 8.36261C19.2097 7.88664 18.689 7.36594 18.213 7.6252L18.0976 7.68808C17.7935 7.85373 17.414 7.69657 17.3161 7.36438L17.279 7.2383ZM16.7575 10.9053C16.1571 10.9053 15.6703 10.4185 15.6703 9.81809C15.6703 9.21764 16.1571 8.73087 16.7575 8.73087C17.358 8.73087 17.8447 9.21764 17.8447 9.81809C17.8447 10.4185 17.358 10.9053 16.7575 10.9053Z"
                fill="white"
              />
              <path
                d="M12.8333 14C12.8333 14 14 14 14 12.8333C14 11.6667 12.8333 8.16667 7 8.16667C1.16667 8.16667 -9.53674e-07 11.6667 -9.53674e-07 12.8333C-9.53674e-07 14 1.16667 14 1.16667 14H12.8333Z"
                fill="white"
              />
              <path
                d="M7 7C5.067 7 3.5 5.433 3.5 3.5C3.5 1.567 5.067 0 7 0C8.933 0 10.5 1.567 10.5 3.5C10.5 5.433 8.933 7 7 7Z"
                fill="white"
              />
            </svg>
          </div>
        )}

        {/* Files */}
        <div className="sideNavIcon">
          {tooltip === "dashboard" && (
            <h1 className="toolTip">
              <div className="sideArrow"></div>
              Dashboard
            </h1>
          )}
          <svg
            className={`mouse-hover ${active === "Dashboard" ? "active" : ""}`}
            onMouseEnter={() => setTooltip("dashboard")}
            onMouseLeave={() => setTooltip("")}
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={() => myProject("/dashboard")}
          >
            <g clipPath="url(#clip0_1598_2271)">
              <path
                d="M15.9629 20.307C15.8555 20.4703 15.6793 20.5691 15.4859 20.5691H6.51406C6.3207 20.5691 6.14023 20.4703 6.03711 20.307C5.93398 20.148 5.92109 19.9504 5.99414 19.7785C6.21328 19.2887 6.70312 18.975 7.24023 18.975H8.31445V18.0297H13.6898V18.975H14.7641C15.3012 18.975 15.7867 19.293 16.0102 19.7785C16.0832 19.9504 16.066 20.1523 15.9629 20.307ZM7.16289 6.76327C6.86641 7.86757 5.85234 8.68398 4.65781 8.68398C3.22695 8.67968 2.0625 7.51952 2.0625 6.08867C2.0625 4.88984 2.87891 3.88007 3.9832 3.58359C3.95312 3.6996 3.97031 3.62226 3.96602 6.08867C3.96602 6.46679 4.27539 6.77617 4.65352 6.77617C7.10703 6.77187 7.04258 6.78476 7.16289 6.76327Z"
                fill="white"
              />
              <path
                d="M7.24883 6.08867C7.24883 6.21327 7.1457 6.3164 7.02109 6.3164H4.65781C4.5332 6.3164 4.43008 6.21327 4.43008 6.08867V3.72538C4.43008 3.59648 4.5332 3.49765 4.65781 3.49765C6.08867 3.49765 7.24883 4.65781 7.24883 6.08867ZM7.02109 10.0719H2.29023C2.16562 10.0719 2.0625 9.96874 2.0625 9.84414C2.0625 9.71953 2.16562 9.6164 2.29023 9.6164H7.02109C7.1457 9.6164 7.24883 9.71953 7.24883 9.84414C7.24883 9.96874 7.1457 10.0719 7.02109 10.0719ZM7.02109 11.4211H2.29023C2.16562 11.4211 2.0625 11.318 2.0625 11.1934C2.0625 11.0687 2.16562 10.9656 2.29023 10.9656H7.02109C7.1457 10.9656 7.24883 11.0687 7.24883 11.1934C7.24883 11.3223 7.1457 11.4211 7.02109 11.4211ZM7.02109 12.7746H2.29023C2.16562 12.7746 2.0625 12.6715 2.0625 12.5469C2.0625 12.4223 2.16562 12.3191 2.29023 12.3191H7.02109C7.1457 12.3191 7.24883 12.4223 7.24883 12.5469C7.24883 12.6715 7.1457 12.7746 7.02109 12.7746ZM11.4469 8.95898V12.3148C11.4469 12.5684 11.2406 12.7746 10.9871 12.7746H10.0332C9.77969 12.7746 9.57344 12.5684 9.57344 12.3148V8.95898C9.57344 8.70546 9.77539 8.49921 10.0332 8.49921H10.9871C11.2406 8.49921 11.4469 8.70546 11.4469 8.95898ZM14.2785 6.5957V12.3148C14.2785 12.5684 14.0723 12.7746 13.8188 12.7746H12.8648C12.6113 12.7746 12.4051 12.5684 12.4051 12.3148V6.5957C12.4051 6.34218 12.607 6.13593 12.8648 6.13593H13.8188C14.0723 6.13593 14.2785 6.34218 14.2785 6.5957ZM17.1059 8.95898V12.3148C17.1059 12.5684 16.8996 12.7746 16.6461 12.7746H15.6879C15.4344 12.7746 15.2281 12.5684 15.2281 12.3148V8.95898C15.2281 8.70546 15.4344 8.49921 15.6879 8.49921H16.6461C16.8996 8.49921 17.1059 8.70546 17.1059 8.95898ZM19.9375 7.5582V12.3148C19.9375 12.5684 19.7312 12.7746 19.4777 12.7746H18.5195C18.266 12.7746 18.0598 12.5684 18.0598 12.3148V7.5582C18.0598 7.30468 18.266 7.09843 18.5195 7.09843H19.4777C19.7312 7.09843 19.9375 7.30468 19.9375 7.5582Z"
                fill="white"
              />
              <path
                d="M16.1691 7.31757C16.1047 7.31757 16.0402 7.28749 15.993 7.23593L13.3203 4.05625L10.6692 6.61718C10.5789 6.70312 10.4328 6.70312 10.3469 6.61289C10.2609 6.52265 10.2609 6.37656 10.3512 6.29062L13.1828 3.55781C13.2301 3.51484 13.2902 3.48906 13.3547 3.49335C13.4191 3.49765 13.4793 3.52773 13.518 3.57499L16.2121 6.78046L18.8719 4.90273C18.975 4.82968 19.1168 4.85546 19.1899 4.95859C19.2629 5.06171 19.2371 5.20351 19.134 5.27656L16.3024 7.2789C16.2637 7.30468 16.2164 7.31757 16.1691 7.31757ZM11 15.4344C10.8281 15.4344 10.6863 15.5762 10.6863 15.748C10.6863 15.9199 10.8281 16.0617 11 16.0617C11.1719 16.0617 11.3137 15.9199 11.3137 15.748C11.3137 15.5762 11.1719 15.4344 11 15.4344Z"
                fill="white"
              />
              <path
                d="M20.8527 1.43085H1.14727C0.511328 1.43085 0 1.94218 0 2.57382V16.4269C0 17.0586 0.511328 17.5742 1.14727 17.5742H20.857C21.4887 17.5742 22.0043 17.0586 22.0043 16.4269V2.57382C22 1.94218 21.4844 1.43085 20.8527 1.43085ZM11 16.5215C10.5746 16.5215 10.2266 16.1734 10.2266 15.748C10.2266 15.3226 10.5746 14.9746 11 14.9746C11.4254 14.9746 11.7734 15.3226 11.7734 15.748C11.7734 16.1734 11.4254 16.5215 11 16.5215ZM21.0848 13.9176H0.915234V2.57382C0.915234 2.44921 1.01836 2.34608 1.14297 2.34608H20.8527C20.9773 2.34608 21.0805 2.44921 21.0805 2.57382V13.9176H21.0848Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_1598_2271">
                <rect width="22" height="22" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        {/* People */}
        {userType === "admin" && (
          <div className="sideNavIcon" onClick={() => myProject("/myCustomer")}>
            {tooltip === "customer" && (
              <h1 className="toolTip">
                <div className="sideArrow"></div>
                Customers
              </h1>
            )}
            <svg
              className={`mouse-hover ${
                active === "myCustomer" ? "active" : ""
              }`}
              onMouseEnter={() => setTooltip("customer")}
              onMouseLeave={() => setTooltip("")}
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M8.75 17.5C8.75 17.5 7.5 17.5 7.5 16.25C7.5 15 8.75 11.25 13.75 11.25C18.75 11.25 20 15 20 16.25C20 17.5 18.75 17.5 18.75 17.5H8.75Z"
                fill="white"
              />
              <path
                d="M13.75 10C15.8211 10 17.5 8.32107 17.5 6.25C17.5 4.17893 15.8211 2.5 13.75 2.5C11.6789 2.5 10 4.17893 10 6.25C10 8.32107 11.6789 10 13.75 10Z"
                fill="white"
              />
              <path
                d="M6.52045 17.5C6.34445 17.1449 6.25 16.7239 6.25 16.25C6.25 14.5557 7.09882 12.8132 8.66991 11.6C7.98262 11.3801 7.18137 11.25 6.25 11.25C1.25 11.25 0 15 0 16.25C0 17.5 1.25 17.5 1.25 17.5H6.52045Z"
                fill="white"
              />
              <path
                d="M5.625 10C7.35089 10 8.75 8.60089 8.75 6.875C8.75 5.14911 7.35089 3.75 5.625 3.75C3.89911 3.75 2.5 5.14911 2.5 6.875C2.5 8.60089 3.89911 10 5.625 10Z"
                fill="white"
              />
            </svg>
          </div>
        )}
        {/* <img className='mouse-hover' src={people} alt='Files' /> */}
        {/* Tools */}
        {userType === "admin" && (
          <div className="sideNavIcon" onClick={() => myProject("/settings")}>
            {tooltip === "setting" && (
              <h1 className="toolTip">
                <div className="sideArrow"></div>
                Settings
              </h1>
            )}
            <svg
              className={`mouse-hover ${active === "settings" ? "active" : ""}`}
              xmlns="http://www.w3.org/2000/svg"
              onMouseEnter={() => setTooltip("setting")}
              onMouseLeave={() => setTooltip("")}
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M11.7558 1.31298C11.2398 -0.437661 8.76017 -0.437661 8.24417 1.31298L8.11904 1.73754C7.78934 2.85613 6.51169 3.38534 5.4876 2.82752L5.09891 2.6158C3.49615 1.74277 1.74277 3.49616 2.6158 5.09891L2.82752 5.4876C3.38534 6.51169 2.85612 7.78934 1.73754 8.11904L1.31298 8.24417C-0.437661 8.76017 -0.437661 11.2398 1.31298 11.7558L1.73754 11.881C2.85613 12.2107 3.38534 13.4883 2.82752 14.5124L2.6158 14.9011C1.74277 16.5038 3.49615 18.2572 5.09891 17.3842L5.4876 17.1725C6.51169 16.6147 7.78934 17.1439 8.11904 18.2625L8.24417 18.687C8.76017 20.4377 11.2398 20.4377 11.7558 18.687L11.881 18.2625C12.2107 17.1439 13.4883 16.6147 14.5124 17.1725L14.9011 17.3842C16.5038 18.2572 18.2572 16.5038 17.3842 14.9011L17.1725 14.5124C16.6147 13.4883 17.1439 12.2107 18.2625 11.881L18.687 11.7558C20.4377 11.2398 20.4377 8.76017 18.687 8.24417L18.2625 8.11904C17.1439 7.78934 16.6147 6.51169 17.1725 5.4876L17.3842 5.09891C18.2572 3.49615 16.5038 1.74277 14.9011 2.6158L14.5124 2.82752C13.4883 3.38534 12.2107 2.85612 11.881 1.73754L11.7558 1.31298ZM10 13.661C7.97808 13.661 6.33898 12.0219 6.33898 10C6.33898 7.97808 7.97808 6.33898 10 6.33898C12.0219 6.33898 13.661 7.97808 13.661 10C13.661 12.0219 12.0219 13.661 10 13.661Z"
                fill="white"
              />
            </svg>
          </div>
        )}
        {/* <img className='mouse-hover' src={tool} alt='Files' /> */}
        {/* Feedback Icon */}
        {/* <div className="sideNavIcon">
          {tooltip === "feedback" && (
            <h1 className="toolTip">
              <div className="sideArrow"></div>
              Support
            </h1>
          )}
          <svg
            className={`mouse-hover`}
            onMouseEnter={() => setTooltip("feedback")}
            onMouseLeave={() => setTooltip("")}
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            
          >
            <path
              d="M1.66699 18.3332V3.33317C1.66699 2.87484 1.83033 2.48262 2.15699 2.1565C2.48366 1.83039 2.87588 1.66706 3.33366 1.6665H16.667C17.1253 1.6665 17.5178 1.82984 17.8445 2.1565C18.1712 2.48317 18.3342 2.87539 18.3337 3.33317V13.3332C18.3337 13.7915 18.1706 14.184 17.8445 14.5107C17.5184 14.8373 17.1259 15.0004 16.667 14.9998H5.00033L1.66699 18.3332ZM10.0003 12.4998C10.2364 12.4998 10.4345 12.4198 10.5945 12.2598C10.7545 12.0998 10.8342 11.9021 10.8337 11.6665C10.8331 11.4309 10.7531 11.2332 10.5937 11.0732C10.4342 10.9132 10.2364 10.8332 10.0003 10.8332C9.76421 10.8332 9.56644 10.9132 9.40699 11.0732C9.24755 11.2332 9.16755 11.4309 9.16699 11.6665C9.16644 11.9021 9.24644 12.1001 9.40699 12.2607C9.56755 12.4212 9.76533 12.5009 10.0003 12.4998ZM9.16699 9.1665H10.8337V4.1665H9.16699V9.1665Z"
              fill="white"
            />
          </svg>
        </div> */}
        {/* </Link> */}
        {/* Arrow */}
        <div className="sideNavIcon">
          {tooltip === "logout" && (
            <h1 className="toolTip">
              <div className="sideArrow"></div>
              Logout
            </h1>
          )}
          <svg
            className="mouse-hover"
            xmlns="http://www.w3.org/2000/svg"
            onMouseEnter={() => setTooltip("logout")}
            onMouseLeave={() => setTooltip("")}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            onClick={() => setShowLogout(true)}
          >
            <path
              d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM5.625 9.375C5.27982 9.375 5 9.65482 5 10C5 10.3452 5.27982 10.625 5.625 10.625H12.8661L10.1831 13.3081C9.93898 13.5521 9.93898 13.9479 10.1831 14.1919C10.4271 14.436 10.8229 14.436 11.0669 14.1919L14.8169 10.4419C15.061 10.1979 15.061 9.80214 14.8169 9.55806L11.0669 5.80806C10.8229 5.56398 10.4271 5.56398 10.1831 5.80806C9.93898 6.05214 9.93898 6.44786 10.1831 6.69194L12.8661 9.375H5.625Z"
              fill="white"
            />
          </svg>
        </div>
        {/* <img className='mouse-hover' src={arrow} alt='Files' /> */}
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        className="sideNavModal actionModal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Save Changes</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to stop editing? You can save this project as
          draft and can continue later.
        </Modal.Body>
        <Modal.Footer>
          {draftLoader && (
            <div className="draftLoader">
              <div className="ring"></div>
              <img src="./images/Logos/flash.svg" alt="logo"></img>
            </div>
          )}
          <Button
            variant="secondary"
            onClick={() =>
              saveAsDraft({
                setDraftLoader,
                navigate,
                roofInfo,
                quantityInfo,
                user,
                reportInfo,
              })
            }
          >
            Save as Draft
          </Button>
          <Button variant="secondary" onClick={() => noProjectSave()}>
            Don't save
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showLogout}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        className="sideNavModal actionModal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Logout</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to logout?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => logOut()}>
            Logout
          </Button>
          <Button variant="secondary" onClick={() => setShowLogout(false)}>
            Discard
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default SideNav;
